'use client';

import { useMemo } from 'react';

import { useAppSelector } from '@/modules/common/hooks/useStore';
import { useUiKey } from '@/modules/common/hooks/useUiKey';

import { AlgoliaHit } from '../models/algolia-hit.interface';
import { selectCacheByUiKey } from '../state/searchResultsSlice';

type UseSearchCacheReturn = {
  cacheItems: AlgoliaHit[];
  hasCacheItems: boolean;
  cacheIsLastPage: boolean;
  uiKey: string;
};

export function useSearchCache(): UseSearchCacheReturn {
  const uiKey = useUiKey();
  const cache = useAppSelector(selectCacheByUiKey(uiKey));

  const cacheItems = useMemo(() => (cache?.items ?? []) as AlgoliaHit[], [cache?.items]);
  const hasCacheItems = (cacheItems?.length ?? 0) > 0;
  const cacheIsLastPage = cache?.isLastPage ?? true;

  return { cacheItems, hasCacheItems, cacheIsLastPage, uiKey };
}
